import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { Resource } from '@opentelemetry/resources';

import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { environment } from './environments/environment';
import { ENV, API_REGEX } from './app/models/general';
import {
  SERVICE_NAME_KEY,
  ENVIRONMENT_KEY,
  SERVICE_NAME,
  SIGNOZ_INGESTION_KEY_HEADER,
  TRACE_ENDPOINT,
} from './app/models/signoz';

if (environment.production) {
  const resource = new Resource({
    [SERVICE_NAME_KEY]: SERVICE_NAME,
    [ENVIRONMENT_KEY]: ENV,
  });

  const provider = new WebTracerProvider({
    resource,
  });

  const exporter = new OTLPTraceExporter({
    url: environment.signozUrl + TRACE_ENDPOINT,
    headers: {
      [SIGNOZ_INGESTION_KEY_HEADER]: environment.signozIngestionKey,
    },
  });

  provider.addSpanProcessor(new BatchSpanProcessor(exporter));
  provider.register();

  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [API_REGEX],
      }),

      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [API_REGEX],
      }),
    ],
  });
}
